import { AgreementsFilter } from '../models/agreement';

export class SetSelectedFilter {
  public static readonly type = '[Agreements] SetSelectedFilter';
  constructor(public filter: AgreementsFilter) { }
}
